import { callbackIntents } from '../consts';

interface GetCallbackIntentsParams {
  shippingOptionRequired: boolean;
  shippingAddressRequired: boolean;
}

// "onPaymentDataChanged callback must be set if any of SHIPPING_ADDRESS,SHIPPING_OPTION,OFFER,PAYMENT_METHOD callback intent is set."
export const getCallbackIntents = (
  params: GetCallbackIntentsParams,
): google.payments.api.PaymentDataRequest['callbackIntents'] => {
  const callbacks: google.payments.api.PaymentDataRequest['callbackIntents'] = [callbackIntents.PAYMENT_AUTHORIZATION];

  // If PaymentDataRequest.callbackIntents contains SHIPPING_OPTION, PaymentDataRequest.shippingOptionRequired must be set to true!
  if (params.shippingOptionRequired) {
    callbacks.push(callbackIntents.SHIPPING_OPTION);
  }

  // If PaymentDataRequest.callbackIntents contains SHIPPING_ADDRESS, PaymentDataRequest.shippingAddressRequired must be set to true!
  if (params.shippingAddressRequired) {
    callbacks.push(callbackIntents.SHIPPING_ADDRESS);
  }

  return callbacks;
};
